export default __webpack_public_path__ + "static/media/sileshi.781fa587.jpg";